import { Icon, IconType } from '@repo/ui/components';
import { FinancingType, getFinancingTypeTranslatedValue } from 'next-common';
import { cn } from 'types';

export const SuccessState = ({ financingType }: { financingType: FinancingType }) => {
  const financingTypeDescription = getFinancingTypeTranslatedValue(financingType);

  return (
    <div
      className={cn(
        'h-[45rem] w-full flex flex-col gap-6 justify-center items-center bg-lightGrey p-4 text-center border-2',
        'border-markTurquoise'
      )}
    >
      <span className="rounded-full flex items-center justify-center bg-markTurquoise">
        <Icon icon={IconType.Check} viewBox="0 0 32 32" width={48} height={48} />
      </span>
      <h3 className="text-oldSilver text-[1.25rem]/[170%] font-semibold">{financingTypeDescription}forslag lagret</h3>
    </div>
  );
};

export const EmptyState = () => (
  <div
    className={cn(
      'h-[45rem] w-full flex flex-col gap-6 justify-center items-center bg-lightGrey p-4 text-center border-2',
      'border-markTurquoise'
    )}
  >
    <span className="rounded-full flex items-center justify-center bg-markTurquoise">
      <Icon icon={IconType.NewNextPen} width={48} height={48} className="p-1" />
    </span>
    <h3 className="text-oldSilver text-[1.25rem]/[170%] font-semibold">
      Marker en rad fra tabellen til venstre for å redigere
    </h3>
  </div>
);
